export default "/images/icon.jpg?055adae2889bf1ab22d3e81e2a5f894b";